<template>
  <div>
    <div class="page-header-wrapper padding-rb">
      <PageHeader title="vCE List">
        <!-- <span style="margin-right: 10px;">vMSL</span>
        <el-select v-model="vMSLId" placeholder="Please select vMSL name" filterable class="select" @change="onSearch">
          <el-option v-for="(item, idx) in options" :key="idx" :label="item.vMSLName" :value="item.vMSLId">
          </el-option>
        </el-select> -->
        
        <el-input class="select" prefix-icon="el-icon-search" placeholder="Search" v-model="searchVal"
          v-debounce="onSearch" clearable @clear="onSearch"  style="margin-right: 0px;"/>
        <el-button type="primary" icon="el-icon-download" @click="openExportReportDialog">
          Download Report
        </el-button>
        <el-button v-role="[2, 3, 13]" type="primary" icon="el-icon-refresh" @click="refreshWeCom">
          Refresh WeCom
        </el-button>

      </PageHeader>
    </div>
    <div class="table-wrapper">
      <el-table ref="table" :data="tableData" v-loading="tableLoading" element-loading-text="Loading..."
        @sort-change="onSortChange" @select="handleSelect" @select-all="handleSelectionAll">
        <template>
          <el-table-column type="selection" width="45" align="center" :selectable="disableSelection" />
        </template>
        <el-table-column prop="SEName" label="Name" min-width="110" sortable="custom" fixed />
        <el-table-column prop="City" label="City" min-width="80" sortable="custom" fixed />
        <el-table-column prop="hospital" label="Hospital / Institution" min-width="180" sortable="custom" fixed />
        <el-table-column prop="Department" label="Department" min-width="140" sortable="custom" fixed />
        <el-table-column prop="Phone" label="Phone" min-width="100" sortable="custom" fixed />
        <!-- <el-table-column prop="LastPushDate" label="Last Push Date" min-width="150" sortable="custom" /> -->
        <el-table-column prop="Types" label="Type" min-width="100" sortable="custom" />
        <el-table-column prop="Tags" label="Tag" min-width="200">
          <template slot-scope="{ row }">
            <hcp-tag-cell :value="row.Tags" />
          </template>
        </el-table-column>
        <!-- <el-table-column prop="EngagementProfile" label="Engagement Profile" width="180" sortable="custom" show-overflow-tooltip/> -->
        <el-table-column prop="TargetMLName" label="vMSL" min-width="100" sortable="custom" />
        <!-- <el-table-column prop="TeamName" label="Team" min-width="130" sortable="custom" /> -->
        <!-- <el-table-column prop="IsWeComEnabled" width="200" label="WeCom Contacts" sortable="custom" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="tagTypeParserForWeComContacts(row.IsWeComEnabled)" effect="dark">
              {{ tagLabelParserForWeComContacts(row.IsWeComEnabled) }}
            </el-tag>
          </template>
        </el-table-column> -->
        <el-table-column prop="Match" width="160" label="iDoctor Match" sortable="custom">
          <template slot-scope="{ row }">
            <el-tag :type="tagTypeParserForiDoctor(row.iDoctorStatus)" effect="dark">
              {{ tagLabelParserForiDoctor(row.iDoctorStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Certified" width="150" label="eMSL Certified" sortable="custom">
          <template slot-scope="{ row }">
            <el-tag :type="tagTypeParser(row.Active)" effect="dark">
              {{ tagLabelParser(row.Active) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="LastSend" label="Last send" min-width="140" sortable="custom" />
        <el-table-column prop="Time" label="Times" min-width="130" sortable="custom" />
        <el-table-column label="Operation" width="200" prop="StatusDesc" align="center">
          <template slot-scope="{ row }">
            
            <el-button :disabled="!row.Phone || row.iDoctorStatus!=2" type="text" icon="el-icon-s-promotion"
              :loading="row.loading" @click="sendMessage(row)" size="mini">
              Send SMS
            </el-button>
            <span style="padding: 0 5px;">|</span>
            <el-button type="text" icon="iconfont icon-transfer" :loading="row.loading"
              @click="openTransferDialog(row)" size="mini">
              Transfer
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <div class="actions">
          <el-button type="text" icon="el-icon-s-promotion" size="medium" @click="handleMultiSend()"
            :disabled="multipleSelection.length === 0">
            Mass Send SMS
          </el-button>
        </div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :pager-count="pagerCount" :page-sizes="[10, 25, 50, 100]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total" />
      </div>
    </div>

    <v-dialog width="480px" title="Export Report" :visible.sync="exportReportDialogVisible" :scrollbar="false"
      @closed="onExportReportClosed">
      <p class="export-report-hint">
        请选择区间日期导出报表，若需导出全量数据，区间日期可留空
      </p>
      <div class="export-report-picker-wrap">
        <el-date-picker
          v-model="exportReportDateRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          start-placeholder="Begin date"
          end-placeholder="End date"
          range-separator="-"
          clearable
          style="width: 100%;"
        />
      </div>
      <div slot="footer" class="dialog-actions">
        <el-button type="primary" @click="onExportReportSubmit" :loading="exportReportLoading">
          {{ exportReportLoading ? 'Exporting...' : 'Submit' }}
        </el-button>
        <el-button @click="exportReportDialogVisible = false">Cancel</el-button>
      </div>
    </v-dialog>

    <v-dialog width="300px" title="Mass Reassign" :visible.sync="massReassignDialogVisible" :scrollbar="false"
      @closed="onMassReassignClosed">
      <el-form ref="massReassignForm" :model="massReassignForm" :rules="massReassignFormRules" label-position="top" style="padding: 0 12%;">
        <el-form-item prop="callCenterUserId" label="Select Call Center">
          <el-select v-model="massReassignForm.callCenterUserId" filterable placeholder="Please select Call Center">
            <el-option v-for="item in callCenterOptions" :key="item.callCenterId" :label="item.callCenterName"
              :value="item.callCenterId" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-actions">
        <el-button type="primary" @click="onMassReassignConfirm" :loading="massReassignSaving">
          {{ massReassignSaving ? "Saving" : "Save" }}
        </el-button>
        <el-button @click="onMassReassignClosed">Cancel</el-button>
      </div>
    </v-dialog>

    <v-dialog width="300px" title="Mass Transfer" :visible.sync="transferDialogVisible" :scrollbar="false"
      @opened="onTransferOpened" @closed="onTransferClosed">
      <div v-if="showTransferTip" class="transfer-tip">
        当前vCE已绑定其他vMSL（{{ transferForm.SourceMLName }}）
        <br />
        请确认选择正确的绑定vMSL人员
      </div>
      <el-form ref="transferFormRef" :model="transferForm" :rules="transferFormRules" label-position="top" style="padding: 0 12%;">
        <el-form-item prop="TargetMLID" label="Select vMSL">
          <el-select v-model="transferForm.TargetMLID" filterable placeholder="Please select vMSL">
            <el-option v-for="item in allVmslOptions" :key="item.vMSLId" :label="item.vMSLName"
              :value="item.vMSLId" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-actions">
        <el-button type="primary" @click="onTransferConfirm" :loading="transferSaving">
          {{ transferSaving ? "Saving" : "Save" }}
        </el-button>
        <el-button @click="onTransferClosed">Cancel</el-button>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import downloadjs from "downloadjs";
import { RoleCode } from "@/utils/role-constant";
import HcpTagCell from "@/components/hcp-tag-cell.vue";

export default {
  name: "My-SE",
  components: {
    HcpTagCell,
  },
  data() {
    return {
      tableLoading: true,
      searchVal: "",
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      orderBy: "CreatedOn",
      orderType: "descending",
      qrcodeDialogVisible: false,
      importSEDialogVieible: false,
      editSEDialogVisible: false,
      rowData: null,
      qrcodeUrl: "",
      multipleSelection: [],
      seIds: null,
      transferSEDialogVisible: false,
      teamId: '',
      options: [],
      vMSLId: '',

      massReassignDialogVisible: false,
      callCenterOptions: [],
      massReassignForm: {
        callCenterUserId: '',
      },
      massReassignFormRules: {
        callCenterUserId: [{ required: true, message: 'Please select Call Center', trigger: 'change' }],
      },
      massReassignSaving: false,

      transferDialogVisible: false,
      allVmslOptions: [],
      transferForm: {
        SourceMLID: '',
        SourceMLName: '',
        TargetMLID: '',
        TargetMLName: '',
      },
      transferFormRules: {
        TargetMLID: [{ required: true, message: 'Please select target vMSL', trigger: 'change' }],
      },
      transferSaving: false,
      transferRow: null,

      exportReportDialogVisible: false,
      exportReportDateRange: null,
      exportReportLoading: false,
    };
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    templateUrl() {
      if (this.role === RoleCode.Admin) {
        return "/template/SEUserImportTemplate.xlsx";
      } else {
        return "/template/SupSEUserImportTemplate.xlsx";
      }
    },
    pagerCount() {
      let clientWidth = document.body.clientWidth;
      return clientWidth <= 1024 ? 5 : 7;
    },
    isVMSL() {
      return this.role === RoleCode.VMSL;
    },
    showTransferTip() {
      return !!this.transferForm.SourceMLID && this.transferForm.SourceMLID !== this.transferForm.TargetMLID
    },
  },
  watch: {
  },
  created() {
    this.getOptions()
    this.getTableData();
    this.bus.$on("refresh", ({ name }) => {
      if (name === "vCE-List") {
        this.getTableData();
      }
    });
  },
  methods: {
    openExportReportDialog() {
      this.exportReportDialogVisible = true;
    },
    onExportReportClosed() {
      this.exportReportLoading = false;
      this.exportReportDateRange = null;
    },
    onExportReportSubmit() {
      if (this.exportReportLoading) return;
      const params = {};
      if (Array.isArray(this.exportReportDateRange) && this.exportReportDateRange.length === 2) {
        params.fromDate = this.exportReportDateRange[0];
        params.toDate = this.exportReportDateRange[1];
      }
      this.exportReportLoading = true;
      const msg = this.$message({
        message: 'Report is exporting...',
        duration: 0,
      });
      this.axios
        .get('/vCE/exportReport', {
          responseType: 'blob',
          params,
        })
        .then(({ data }) => {
          downloadjs(
            data.file,
            data.fileName,
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          );
          msg.close();
          this.$message.success('Export report successful!');
          this.exportReportDialogVisible = false;
        })
        .catch(() => {
          msg.close();
          this.$message.error('Export report failed!');
        })
        .finally(() => {
          this.exportReportLoading = false;
        });
    },
    refreshWeCom(){
      this.axios
        .get(`/se/refreshWeCom`)
        .then(({ code, msg }) => {
          if (200 === code) {
            this.$message({
              type: "success",
              message: 'Refresh WeCom Success.',
            });
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        })
        .catch(() => {
        });
    },
    handleMultiSend() {
      if (this.multipleSelection.length === 0) {
        return;
      }
      this.$confirm(
        "Please make sure if it is ready to send sms?",
        "Attention",
        {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
        }
      )
        .then(() => {
          let seIds = this.multipleSelection;
          this.axios
            .post("/vCE/batchSendSMS", {
              seIds: seIds,
            })
            .then(({ code, msg,data}) => {
              if (code === 200) {
                this.getTableData();
                const {successCount, failureCount} = data
                let  msg= `Send Successful :  ${successCount}, Send failed : ${failureCount}`
                this.$message.success(msg);
              } else {
                this.$message.error(msg);
              }
            });
        })
        .catch(() => { });
    },
    sendMessage(row) {
      if(row.loading) return
      row.loading = true
      this.axios
        .post("/vCE/sendSMS", {
          seId: row.SEID,
        })
        .then(({ code, msg }) => {
          row.loading = false
          if (code === 200) {
            this.getTableData();
            this.$message.success("Send SMS successfully");
          } else {
            this.$message.error(msg);
          }
        }).catch(() => {
          row.loading = false
        });
    },
    disableSelection(row) {
      // Call Center 的“勾选”用于转交/下放维护关系，不应被短信/入组状态限制
      if (this.role === RoleCode.CallCenter) return true
      let status = true
      if (row.iDoctorStatus !== 2 || !row.Phone) {
        status = false
      }
      return status
    },
    operateUpload(data) {
      this.$refs.tableDialog.open(data);
    },
    handleUpload(command) {
      switch (command) {
        case "1":
          this.importSEDialogVieible = true;
          break;
        case "3":
          this.$refs.batchAddDialog.open();
          break;
      }
    },
    handleCommand(command) {
      switch (command) {
        case "1":
          this.exportMSLList();
          break;
        case "2":
          this.exportSEList();
          break;
        case "3":
          this.downloadTemplate();
          break;
      }
    },
    downloadTemplate() {
      this.axios
        .get(this.templateUrl, {
          baseURL: "/",
          responseType: "blob",
        })
        .then((data) => {
          downloadjs(
            data,
            `HCP_Import_Template.xlsx`,
            "application/vnd.ms-excel"
          );
          this.$message.success(`Download import template  successful!`);
        });
    },
    exportMSLList() {
      const msg = this.$message({
        message: `MSL list is exporting...`,
        duration: 0,
      });
      this.axios
        .get(`/user/exportUserList`, {
          responseType: "blob",
        })
        .then(({ data }) => {
          downloadjs(data.file, data.fileName, "application/vnd.ms-excel");
          msg.type = "success";
          msg.message = `Export MSL list successful!`;
          setTimeout(() => {
            msg.close();
          }, 3000);
        })
        .catch(() => {
          msg.type = "error";
          msg.message = `Export MSL list failure!`;
          setTimeout(() => {
            msg.close();
          }, 3000);
        });
    },
    exportSEList() {
      this.disableExportSEUser = true;
      const msg = this.$message({
        message: "SE/CE List is exporting...",
        duration: 0,
      });
      this.axios
        .get("/se/export", {
          responseType: "blob",
          params: {
            exportType: "Hcp",
          },
        })
        .then(({ data }) => {
          downloadjs(data.file, data.fileName, "application/vnd.ms-excel");
          msg.type = "success";
          msg.message = "Export SE/CE List successful!";
          setTimeout(() => {
            msg.close();
          }, 3000);
        })
        .catch(() => {
          msg.type = "error";
          msg.message = "Export SE/CE List failure!";
          setTimeout(() => {
            msg.close();
          }, 3000);
        });
    },
    tagTypeParser(flag) {
      let type = ''
      switch (flag) {
        case 0:
          type = 'danger'
          break;
        case 1:
          type = 'success'
          break;
        case 2:
          type = 'warning'
          break;
        default:
          type = 'danger'
          break;
      }
      return type
    },
    tagTypeParserForWeComContacts(flag) {
      let type = ''
      switch (flag) {
        case 0:
          type = 'danger'
          break;
        case 1:
          type = 'success'
          break;
        default:
          type = 'danger'
          break;
      }
      return type
    },
    tagLabelParserForWeComContacts(flag) {
      let label = ''
      switch (flag) {
        case 0:
          label = 'No'
          break;
        case 1:
          label = 'Yes'
          break;
        default:
          label = 'No'
          break;
      }
      return label
    },
    tagTypeParserForiDoctor(flag) {
      let type = ''
      switch (flag) {
        case 2:
          type = 'success'
          break;
        default:
          type = 'danger'
          break;
      }
      return type
    },
    tagLabelParserForiDoctor(flag) {
      let label = ''
      switch (flag) {
        case 2:
          label = 'Match'
          break;

        default:
          label = 'Mismatch'
          break;
      }
      return label
    },
    tagLabelParser(flag) {
      let label = ''
      switch (flag) {
        case 0:
          label = 'Uncertified'
          break;
        case 1:
          label = 'Certified'
          break;
        case 2:
          label = 'Pending certification'
          break;

        default:
          label = 'Uncertified'
          break;
      }
      return label
    },
    onSearch() {
      this.currentPage = 1;
      this.getTableData();
    },
    getOptions() {
      this.axios.get(`/vCE/vMSLList`).then(({ code, data, msg }) => {
        if (code == 200) {
          this.options = [
            {
              vMSLName: "All",
              vMSLId: "",
            },
            ...data,
          ];
        } else {
          this.$message({
            type: "error",
            message: msg,
          });
        }
      });
    },
    getTableData() {
      this.tableLoading = true;
      let params = {
        pageSize: this.pageSize,
        page: this.currentPage,
        orderBy: this.orderBy,
        orderType: this.orderType,
        teamId: this.teamId,
        key: this.searchVal,
        vMSLId:this.vMSLId
      };
      this.axios
        .get(`/vCE/vCEList`, {
          params: params,
        })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.tableData = data.data;
            this.tableData = this.tableData.map((item) => {
              return {
                loading: false,
                ...item,
              }
            })
            this.total = data.total;
            this.toggleRowSelection();
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getTableData();
    },
    handleSelect(selection, row) {
      let index = this.multipleSelection.findIndex((SEID) => SEID === row.SEID);
      if (index === -1) {
        this.multipleSelection.push(row.SEID);
      } else {
        this.multipleSelection.splice(index, 1);
      }
    },
    handleSelectionAll(select) {
      if (select.length > 0) {
        let seIds = Array.from(select, (i) => i.SEID);
        let result = seIds.filter((x) => {
          return !this.multipleSelection.some((y) => y === x);
        });
        this.multipleSelection = this.multipleSelection.concat(result);
      } else {
        let seIds = Array.from(this.tableData, (i) => i.SEID);
        seIds = seIds.filter((x) => {
          return this.multipleSelection.some((y) => y === x);
        });
        let result = this.multipleSelection.filter((x) => {
          return !seIds.some((y) => y === x);
        });
        this.multipleSelection = result;
      }
    },
    toggleRowSelection() {
      let rows = this.tableData.filter((i) => {
        return this.multipleSelection.some((SEID) => SEID === i.SEID);
      });
      rows.forEach((row) => {
        this.$nextTick(() => {
          this.$refs.table.toggleRowSelection(row, true);
        });
      });
    },
    onSuccess(resetPage = false) {
      this.orderBy = resetPage ? "CreatedOn" : this.orderBy;
      this.currentPage = resetPage ? 1 : this.currentPage;
      this.multipleSelection = [];
      this.getTableData();
    },
    onSortChange(column) {
      this.orderBy = column.prop;
      this.orderType = column.order;
      this.getTableData();
    },
    handleEdit(row) {
      this.rowData = row;
      this.editSEDialogVisible = true;
    },
    getQRCode(row) {
      this.rowData = row;
      this.qrcodeDialogVisible = true;
    },
    handleDelete(seId) {
      if (!seId) {
        return;
      }
      this.$confirm("Once deleted, it cannot be recovered.", "Attention", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
      })
        .then(() => {
          let seIds = [seId];
          this.axios
            .post("/se/freeze", {
              seId: seIds,
            })
            .then(({ code, msg }) => {
              if (code === 200) {
                this.getTableData();
                this.$message.success("Delete SE/CE successfully");
              } else {
                this.$message.error(msg);
              }
            });
        })
        .catch(() => { });
    },

    handleTransferSE() {
      this.seIds = [].concat(this.multipleSelection);
      this.transferSEDialogVisible = true;
    },

    async handleMassReassign() {
      if (this.multipleSelection.length === 0) return
      this.massReassignDialogVisible = true
      if (!this.callCenterOptions || this.callCenterOptions.length === 0) {
        await this.getCallCenterOptions()
      }
      if (this.massReassignForm.callCenterUserId) return
      if (this.callCenterOptions && this.callCenterOptions.length > 0) {
        this.massReassignForm.callCenterUserId = this.callCenterOptions[0].callCenterId
      }
    },

    onMassReassignClosed() {
      this.massReassignDialogVisible = false
      this.massReassignSaving = false
      this.massReassignForm.callCenterUserId = ''
      this.$refs.massReassignForm && this.$refs.massReassignForm.resetFields && this.$refs.massReassignForm.resetFields()
    },

    async getCallCenterOptions() {
      const { code, data, msg } = await this.axios.get(`/vCE/callCenterList`)
      if (code === 200) {
        this.callCenterOptions = data || []
      } else {
        this.$message.error(msg)
      }
    },

    async onMassReassignConfirm() {
      if (this.massReassignSaving) return
      if (this.multipleSelection.length === 0) return

      this.$refs.massReassignForm.validate(async (valid) => {
        if (!valid) return
        this.massReassignSaving = true
        try {
          const { code, msg } = await this.axios.post('/vCE/massReassignCallCenter', {
            seIds: this.multipleSelection,
            callCenterUserId: this.massReassignForm.callCenterUserId,
          })
          if (code === 200) {
            this.$message.success('Mass Reassign successfully')
            this.massReassignDialogVisible = false
            this.onSuccess()
          } else {
            this.$message.error(msg)
          }
        } catch (e) {
          this.$message.error('Mass Reassign failed')
        } finally {
          this.massReassignSaving = false
        }
      })
    },

    openTransferDialog(row) {
      if (!row) return
      this.transferRow = row
      this.transferForm.SourceMLID = row.SourceMLID || row.MLID || ''
      this.transferForm.SourceMLName = row.SourceMLName || row.MLName || row.vMLName || ''
      this.transferForm.TargetMLID = row.TargetMLID || row.SourceMLID || row.MLID || 'NA'
      this.transferForm.TargetMLName = row.TargetMLName || this.transferForm.SourceMLName || 'NA'
      this.transferDialogVisible = true
      this.$set(row, 'loading', false)
    },

    async onTransferOpened() {
      if (this.allVmslOptions && this.allVmslOptions.length > 0) return
      const { code, data, msg } = await this.axios.get('/se/vmlList?type=transfer')
      if (code === 200) {
        this.allVmslOptions = [
          {
            vMSLId: 'NA',
            vMSLName: 'NA',
          },
          ...Array.from(data, (i) => ({
          vMSLId: i.UserID,
          vMSLName: i.Name,
        })),
        ]
      } else {
        this.$message.error(msg)
      }
    },

    onTransferClosed() {
      this.transferDialogVisible = false
      this.transferSaving = false
      this.transferRow = null
      this.transferForm.SourceMLID = ''
      this.transferForm.SourceMLName = ''
      this.transferForm.TargetMLID = ''
      this.transferForm.TargetMLName = ''
    },

    async onTransferConfirm() {
      if (this.transferSaving) return
      if (!this.transferRow) return
      this.$refs.transferFormRef.validate(async (valid) => {
        if (!valid) return

        // const sourceVmslId = this.transferForm.sourceVmslId
        const targetVmslId = this.transferForm.TargetMLID === 'NA' ? '' : this.transferForm.TargetMLID

        const doTransfer = async () => {
          this.transferSaving = true
          if (this.transferRow) this.$set(this.transferRow, 'loading', true)
          const row = this.transferRow
          const normalizeMlId = (id) => (id && String(id) !== 'NA' ? id : '')
          const sourceMLId = normalizeMlId(row.SourceMLID || row.MLID)
          const targetMLId = normalizeMlId(
            row.TargetMLID || row.SourceMLID || row.MLID,
          )
          try {
            const { code, msg } = await this.axios.post('/vCE/massTransfer', {
              seId: [this.transferRow.SEID],
              userId: targetVmslId,
              targetMLId,
              sourceMLId,
            })
            if (code === 200) {
              this.$message.success('Transfer successfully')
              this.transferDialogVisible = false
              this.onSuccess()
            } else {
              this.$message.error(msg)
            }
          } catch (e) {
            this.$message.error('Transfer failed')
          } finally {
            if (this.transferRow) this.$set(this.transferRow, 'loading', false)
            this.transferSaving = false
          }
        }

        // // vCE already bound vMSL, and target vMSL differs -> show confirm prompt
        // if (sourceVmslId && sourceVmslId !== targetVmslId) {
        //   this.$confirm(
        //     'This vCE is already bound to a vMSL. Transferring to another vMSL will adjust its maintenance relationship. Do you want to continue?',
        //     'Attention',
        //     {
        //       confirmButtonText: 'Confirm',
        //       cancelButtonText: 'Cancel',
        //     },
        //   )
        //     .then(() => doTransfer())
        //     .catch(() => {})
        // } else {
          await doTransfer()
        // }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination-wrap {
  display: flex;
  justify-content: space-between;

  .actions {
    display: flex;
  }

  .transfer-actions,
  .el-button {
    margin-left: 10px;
  }
}

.dialog-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.transfer-tip {
text-align: center;
  margin-bottom: 8px;
  color: #303133;
  line-height: 1.4;
}

.export-report-hint {
  text-align: center;
  margin: 0 0 16px;
  color: #303133;
  line-height: 1.5;
  font-size: 14px;
}

.export-report-picker-wrap {
  padding: 0 8%;
}

.ml10 {
  margin-left: 10px;
}

.select {
  margin-right: 15px;
  width: 200px;
}
</style>
